module.exports = __webpack_public_path__ + "cdc302570c32874ebc49f5b6f70a4dee.svg";